import React from "react"
import {useAudioStreamURL} from "../hooks/useAudioStreamURL";

type AudioFilePlayerProps = {
    id?: string,
    updatedAt?: string,
}

export function AudioFilePlayer({id, updatedAt}: AudioFilePlayerProps) {
    const {url, isLoading, error} = useAudioStreamURL(id, updatedAt);

    if (!id) return null;
    if (isLoading) return <p>Loading...</p>
    if (error) return <p>Error loading file</p>
    if (url) return <audio controls src={url} className="w-full"/>
    return null
}
